//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    props: ['label', 'placeholder', 'isRequired', 'accentColor', 'index'],
    data() {
        return {
            value: ''
        }
    },
    watch: {
        value: function() {
            this.$emit('update-value', {value: this.value, index: this.index})
        }
    }
}
